import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { navigate } from "../../../store/navigation/operations";

import { Popover, Position, NonIdealState, Button } from "@blueprintjs/core";
import ConversationMemberSelector from "../ConversationMemberSelector";
import { fetchConversations } from "../../../store/messaging/operations";
import ConversationItem from "../../../components/messaging/ConversationItem";
import { Translate, I18n } from "react-redux-i18n";
import {
  isLoadingConversations,
  getCircleConversations,
  getSimpleConversations,
} from "../../../store/messaging/selectors";
import { isLoggedIn } from "../../../store/iam/selectors";

import ReduxLinkDecorator from "../../../containers/ReduxLinkDecorator";
export class Conversations extends Component {
  constructor(props) {
    super(props);
    this.conversationItemClicked = this.conversationItemClicked.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isLoggedIn !== prevProps.isLoggedIn) {
      this.props.fetchConversations();
    }
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.fetchConversations();
    }
  }
  conversationItemClicked(conversation) {
    this.props.navigate(`/messages/${conversation["c_guid"]}`);
  }
  render() {
    return (
      <section className="gray-bg">
        <div className="main-container">
          <div className="content-wrapper">
            {this.props.circleConversations.length === 0 && this.props.simpleConversations.length === 0 && (
              <div className="custom-card">
                <NonIdealState
                  icon="chat"
                  title={I18n.t("messages.title")}
                  description={I18n.t("messages.description")}
                  action={
                    <ReduxLinkDecorator goTo="new-circle">
                      <Button intent="primary" fill={false}>
                        <Translate value="messages.create_circle" />
                      </Button>
                    </ReduxLinkDecorator>
                  }
                />
                <div className="spacer-16" />
              </div>
            )}
            {(this.props.circleConversations.length > 0 || this.props.simpleConversations.length > 0) && (
              <div className="custom-card notification-container">
                <div className="header">
                  <h1>
                    <Translate value="messaging.title" />
                  </h1>
                  <Popover
                    content={
                      <div>
                        <ConversationMemberSelector />
                      </div>
                    }
                    position={Position.BOTTOM_RIGHT}>
                    <Button intent="primary" fill={false} className="secondary-color small" icon="edit">
                      <Translate value="messaging.new_message_button" />
                    </Button>
                  </Popover>
                </div>
                <div className="notification-listing full-page messages">
                  {this.props.circleConversations.length > 0 && (
                    <Fragment>
                      <div className="list-heading">
                        <Translate value="messaging.messages_inside_circles_label" />
                      </div>
                      {this.props.circleConversations.map((conversation) => (
                        <ConversationItem
                          key={conversation.c_at}
                          conversation={conversation}
                          locale={this.props.locale}
                          onClick={this.conversationItemClicked}
                        />
                      ))}
                    </Fragment>
                  )}
                  {this.props.simpleConversations.length > 0 && (
                    <Fragment>
                      <div className="list-heading">
                        <Translate value="messaging.personal_messages_label" />
                      </div>
                      {this.props.simpleConversations.map((conversation) => (
                        <ConversationItem
                          key={conversation.c_at}
                          conversation={conversation}
                          locale={this.props.locale}
                          onClick={this.conversationItemClicked}
                        />
                      ))}
                    </Fragment>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: isLoggedIn(state),
    loading: isLoadingConversations(state),
    circleConversations: getCircleConversations(state),
    simpleConversations: getSimpleConversations(state),
    locale: state.i18n.locale,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchConversations: (id) => dispatch(fetchConversations()),
  navigate: (to) => dispatch(navigate(to)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Conversations);
